import { KeyValue } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { ClientInputContent } from 'client/models';
import { InputDataSourceTypes } from 'common/enums';
import { IExecuteRuleRequest } from 'common/model';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, Subscription } from 'rxjs';
import { ClientEvideFormService } from '../services/client-evide-form.service';
import { onErrorAlert } from 'common/helper';
import { FormStore } from '../common/form.store';

@Component({
  templateUrl: './answer-type.component.html',
  standalone: false
})
export class AnswerTypeComponent {

  @Input() inputContent!: ClientInputContent;
  @Input() formControlObj!: AbstractControl & any;

  public optionsObs: Observable<ReadonlyArray<KeyValue<string, string>>> = of([]);
  public isOptionLoading = false;

  private typSubs = new Subscription();

  constructor(
    private alert: ToastrService,
    private clientEvideFormService: ClientEvideFormService
  ) { }

  ngOnInit() {
    this.init();
    const sub = FormStore.reset$.subscribe(() => {
      setTimeout(() => {
        this.init();
      }, 10)
    });
    this.typSubs.add(sub);
  }

  ngOnDestroy() {
    this.typSubs.unsubscribe();
  }

  private init() {
    // Contact reference field: pre-fill from the non-rule generator on a NEW submission (empty field), leave it
    // editable, and don't run the old rule. Web forms are always new, so there is nothing to preserve.
    if (this.inputContent.isReferenceField) {
      if (!this.formControlObj.value) {
        this.clientEvideFormService.generateContactReference().subscribe({
          next: (ref) => {
            if (ref && !this.formControlObj.value) {
              this.formControlObj.patchValue(ref);
            }
          },
          error: (err) => { console.error('Contact reference generation failed', err); }
        });
      }
      return;
    }

    if (this.inputContent.inputDataSourceType === InputDataSourceTypes.DynamicMulti || this.inputContent.inputDataSourceType === InputDataSourceTypes.DynamicSingle) {
      this.hadnleDynamicDataSourceType();
    }

    if (!this.formControlObj.value && (this.inputContent.defaultValue) && this.inputContent.hasDefaultValue) {
      if (this.inputContent.defaultValue) {
        this.formControlObj.patchValue(this.inputContent.defaultValue);
      }
    }
  }

  private hadnleDynamicDataSourceType() {
    const body: IExecuteRuleRequest = {
      evideInputContentGuid: this.inputContent.inputContentGuid,
      parameters: this.inputContent.ruleParemeters
    }
    this.optionLoading = true;
    this.clientEvideFormService.executeRule(body).subscribe(
      {
        next: res => {
          if (this.inputContent.inputDataSourceType === InputDataSourceTypes.DynamicMulti) {
            const multiValues = res.multiValues;
            const options: KeyValue<string, string>[] = Object.keys(multiValues).map((key: string) => ({
              key, value: multiValues[key]
            }))
            this.optionsObs = of(options);
            // Download PDF: the server only knows static option labels, so keep the ones this rule
            // returned to send with the PDF request.
            FormStore.ruleOptionLabels[this.inputContent.inputContentGuid] = { ...multiValues };
          } else {
            const formControlObj = this.formControlObj as FormControl;
            if (!formControlObj.value) {
              (this.formControlObj as FormControl).patchValue(res.singleValue);
            }
          }
          this.optionLoading = false;
        },
        error: (err) => {
          onErrorAlert(this.alert, err);
          this.optionLoading = false;
        },

      }
    );
  }

  private set optionLoading(disable) {
    this.isOptionLoading = disable;
    this.isOptionLoading ? this.formControlObj.disable() : this.formControlObj.enable()
  }

}
